
/**
 * @export
 * @enum {string}
 */
export enum PackageSize {
    CUSTOM = 'CUSTOM',
    SMALL = 'SMALL',
    MEDIUM = 'MEDIUM',
    LARGE = 'LARGE',
    INSTITUTIONAL = 'INSTITUTIONAL'
}